import _ from 'lodash';
import createjs from 'createjs-collection';

import * as fJS from './../cjsRoot/fJS';
import { cjsSelect } from './cjsSelect';
import { cjsEffects } from './../cjsObjects/cjsEffects';

import STORE from '@/store';

var blockMove = false;
var checks = [];
var showUp = [];
var removeCorrect = [];

export class cjsMemo extends cjsSelect {
  _pairedNumber;
  _show;

  constructor(obj) {
    super(obj);
  }

  create() {
    if (typeof this.otherProperty.registrationPoint !== 'object') this.otherProperty.registrationPoint = {};
    this.otherProperty.registrationPoint.x = this.pos.width / 2;
    this.otherProperty.registrationPoint.y = this.pos.height / 2;

    super.create();

    this.show = false;
    this.check.toVisible = this.check._container.visible = true;
    this.check._container.cache(0, 0, this.check.width, this.check.height);
  }

  setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules) {
    super.setOtherProperty(idGroup, sets, layoutGroup, layoutItem, rules);

    this._pairedNumber =
      typeof this.otherProperty.pair === 'object' && fJS.isNumeric(this.otherProperty.pair.pairedNumber) === true
        ? this.otherProperty.pair.pairedNumber
        : this._stage.defConfig.pair.pairedNumber;
  }

  stageMouseClick(e, data) {
    let engine = data.engine,
      stage = data.cjsStage,
      idItem =
        engine.id + (typeof engine.clone != 'undefined' && engine.clone != null ? '_' + engine.clone.nrCopy : '');

    console.log(idItem + ' CLICK ' + blockMove);
    if (engine.block === true || blockMove === true) {
      e.stopPropagation();
      return false;
    }

    if (engine.check.visible === false) {
      engine.show = false;
      showUp.push({
        idGroup: engine.idGroup,
        idItem: idItem,
        visible: true,
        toSet: true,
      });
      e.stopPropagation();
      return false;
    }

    engine.show = true;
    showUp.push({
      idGroup: engine.idGroup,
      idItem: idItem,
      visible: false,
      toSet: true,
    });

    let good = 0,
      bad = 0;
    for (let i in stage.groups[engine.idGroup].items) {
      if (
        stage.groups[engine.idGroup].items[i].block === true ||
        (stage.groups[engine.idGroup].items[i].block === false && stage.groups[engine.idGroup].items[i].show === false)
      )
        continue;

      if (engine.id === stage.groups[engine.idGroup].items[i].id) {
        good++;
      } else {
        bad++;
      }
    }

    console.log('GOOD: ' + good + ' BAD: ' + bad + ' PN: ' + engine.pairedNumber);
    if (good + bad < engine.pairedNumber) {
      e.stopPropagation();
      return false;
    }

    if (good === engine.pairedNumber && bad === 0) {
      console.log('GOOOOD');
      for (let i in stage.groups[engine.idGroup].items) {
        if (
          stage.groups[engine.idGroup].items[i].block === true ||
          stage.groups[engine.idGroup].items[i].show === false ||
          engine.id !== stage.groups[engine.idGroup].items[i].id
        ) {
          continue;
        }
        console.log(engine.id + ' ' + stage.groups[engine.idGroup].items[i].id);

        stage.groups[engine.idGroup].items[i].isCorrect = true;
        stage.groups[engine.idGroup].items[i].block = true;
        if (engine.removeCorrect === true) {
          removeCorrect.push({
            idGroup: engine.idGroup,
            idItem: i,
            toSet: true,
          });
        }
      }

      let isCorrect = cjsMemo.checkGameAction.call(this, stage, false);
      if (stage.autoCheckAllCorrect === true && isCorrect === true) {
        console.log('autoCheckAllCorrect');
        STORE.dispatch('checkGame');
      }
      e.stopPropagation();
      return false;
    }

    console.log('BAD?');

    for (let i in stage.groups[engine.idGroup].items) {
      if (
        stage.groups[engine.idGroup].items[i].block === true ||
        stage.groups[engine.idGroup].items[i].show === false
      ) {
        continue;
      }

      checks.push({
        idGroup: engine.idGroup,
        idItem: i,
        wait: stage.groups[engine.idGroup].items[i].check.waitStart,
        visible: true,
        toSet: true,
      });
    }

    e.stopPropagation();
  }

  get pairedNumber() {
    return this._pairedNumber;
  }

  get removeCorrect() {
    return this.otherProperty.pair.hide.removeCorrect;
  }

  get show() {
    return this._show;
  }

  set show(v) {
    this._show = v;
  }
}

cjsMemo.tick = function (stage) {
  if (showUp.length > 0) {
    for (let i = 0; i < showUp.length; i++) {
      let item = stage.groups[showUp[i].idGroup].items[showUp[i].idItem];
      if (showUp[i].toSet === true) {
        item.check._moved = true;
        item.check.visible = showUp[i].visible;
        item.check.wait = 0;
        showUp[i].toSet = false;
      }
      if (cjsEffects[item.check.effect].call(this, item.check) === false) {
        continue;
      }
      showUp.splice(i, 1);
    }
  } else {
    for (let i = 0; i < checks.length; i++) {
      let item = stage.groups[checks[i].idGroup].items[checks[i].idItem];
      if (checks[i].toSet === true) {
        item.check._moved = true;
        item.check.visible = checks[i].visible;
        item.check.wait = checks[i].wait;
        checks[i].toSet = false;
      }
      if (cjsEffects[item.check.effect].call(this, item.check) === false) {
        continue;
      }
      console.log(checks[i].idItem + ' ' + item.check.visible);
      item.show = false;
      checks.splice(i, 1);
    }
  }

  if (checks.length === 0 && showUp.length === 0 && removeCorrect.length > 0) {
    for (let i = 0; i < removeCorrect.length; i++) {
      let item = stage.groups[removeCorrect[i].idGroup].items[removeCorrect[i].idItem];
      if (removeCorrect[i].toSet === true) {
        item._moved = true;
        item.toVisible = false;
        item.time = new Date();
        item.wait = 300;
        removeCorrect[i].toSet = false;
      }
      if (cjsEffects['hide'].call(this, item) === false) {
        continue;
      }
      removeCorrect.splice(i, 1);
    }
  }

  blockMove = checks.length > 0 || showUp.length > 0;
};

cjsMemo.checkGameAction = function (stage, droped) {
  let isCorrect = true;
  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      isCorrect = stage.groups[gr].items[i].isCorrect !== true ? false : isCorrect;
    }
  }
  return isCorrect;
};

cjsMemo.resetGameAction = function (stage) {
  console.log('cjsMemo RESET');
  blockMove = false;
  showUp.splice(0, showUp.length);
  checks.splice(0, checks.length);
  removeCorrect.splice(0, removeCorrect.length);
};
